import { useParams, useNavigate } from 'react-router-dom'
import { Pencil, ArrowLeft } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { Skeleton } from '@/shared/components/ui/skeleton'
import { useDocumentTitle } from '@/shared/hooks/use-document-title'
import { useCampania } from '@/modules/multichannel/hooks/useCampanias'
import { CampaniaCreateForm } from '@/modules/multichannel/components/CampaniaCreateForm'

export function CampaniaEdit() {
  const { id } = useParams<{ id: string }>()
  const campaniaId = Number(id)
  const navigate = useNavigate()
  const { data: campania, isLoading, isError } = useCampania(campaniaId)

  useDocumentTitle(campania ? `Editar: ${campania.nombre_campania}` : 'Editar Campaña')

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-[600px] w-full" />
      </div>
    )
  }

  if (isError || !campania) {
    return (
      <div className="text-center py-16 text-muted-foreground">
        <p>No se pudo cargar la campaña</p>
        <Button variant="outline" className="mt-4" onClick={() => navigate(-1)}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Volver
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
          <Pencil className="h-6 w-6" />
          Editar Campaña
        </h1>
        <p className="text-muted-foreground mt-1">{campania.nombre_campania}</p>
      </div>

      <CampaniaCreateForm initialData={campania} mode="edit" />
    </div>
  )
}
